import {Injectable, state} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from "@angular/router";
import {Observable} from "rxjs";
import {AuthService} from "./auth.service";

@Injectable()
export class TransGuard implements CanActivate{

  constructor(private authservice:AuthService,private router: Router){}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|Promise<boolean>|boolean {

    return this.authservice.authInto$
      .map(authInfo => authInfo.isLoggedIn())
      .take(1)
      .do(
        allowed => {
          if(!allowed){
            this.router.navigate(['/home']);
          }
        } );

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/security/trans-guard.ts